import React from "react";
import "./flexiaccessconfirmmodal.scss";
import { Row, Col } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";

const FlexiAccessConfirmModal = (props) => {
  return (
    <div className="parent-flexi-confirmation">
      <Row>
        <Col>
          <div className="confirmation-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="confirm-pop-title mb-3">
          <div>{props.modaltitle}</div>
        </Col>
      </Row>
      <Row>
        <Col className="confirm-pop-desc mb-3">
          <div>Your Flexi-access income has now been updated.</div>
        </Col>
      </Row>
      <Row style={{ paddingLeft: "12px" }}>
        <Col>
          <div className="text-end">
            <Buttons
              className="primary"
              name="Continue"
              handleClick={props.handleContinue}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FlexiAccessConfirmModal;
